import "@ms-mwf/moray/dist/css/main.css";
import * as React from "react";
import Text from "src/components/text/Text";
import "./NavigationCard.scss";
const { useState, useRef } = React;

export interface INavigationCardProps {
  category: string;
  navigationCardTitle: string;
  navigationCardDescription: string;
  navigationCardNeedMoreHelp?: string;
  navigationCardTab1: string;
  navigationCardTab2: string;
  navigationCardTab3?: string;
  navigationCardTab4?: string;
  navigationCardTab5?: string;
  navigationCardContent1: JSX.Element;
  navigationCardContent2: JSX.Element;
  navigationCardContent3?: JSX.Element;
  navigationCardContent4?: JSX.Element;
  navigationCardContent5?: JSX.Element;
}
const NavigationCard: React.FunctionComponent<INavigationCardProps> = props => {
  const [tab, setTab] = useState(0);
  const tabRefs = useRef<(HTMLAnchorElement | null)[]>([]);
  const tabSelected = (selectedTab: number) => (selectedTab === tab ? "tab-selected" : "");
  const ariaSelected = (selectedTab: number) => (selectedTab === tab ? "true" : "false");
  const presentTabs = [0, 1];
  if (props.navigationCardTab3 !== undefined) presentTabs.push(2);
  if (props.navigationCardTab4 !== undefined) presentTabs.push(3);
  if (props.navigationCardTab5 !== undefined) presentTabs.push(4);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>, index: number) => {
    const tabs = tabRefs.current.filter(Boolean) as HTMLAnchorElement[];
    const currentIndex = tabs.indexOf(e.currentTarget);
    if(e.key === 'Tab') {
    } 
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      const prevIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
      setTab(presentTabs[prevIndex]);
      tabs[prevIndex]?.focus();
    } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      const nextIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
      setTab(presentTabs[nextIndex]);
      tabs[nextIndex]?.focus();
    } else if (e.key === 'Home') {
      e.preventDefault();
      setTab(presentTabs[0]);
      tabs[0]?.focus();
    } else if (e.key === 'End') {
      e.preventDefault();
      setTab(presentTabs[tabs.length - 1]);
      tabs[tabs.length - 1]?.focus();
    } else if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      e.currentTarget.click();
    }
  };
  return (
    <section className="navigation-card">
      <div id="navigation-card-title" className="material-surface" data-mount="click-group">
        <h2 className="navigation-card-title mt-4 mb-3 ml-4 h3">
          <Text category={props.category} id={props.navigationCardTitle} />
        </h2>
        <p id="navigation-card-description" className="ml-4 base">
          <Text category={props.category} id={props.navigationCardDescription} />
        </p>
        {props.navigationCardNeedMoreHelp !== undefined && (
          <p id="navigation-card-need-more-help-section" className="ml-4 base">
            <Text category={props.category} id={props.navigationCardNeedMoreHelp} />
          </p>
        )}
      </div>
      <div className="solutions-tabs pt-0">
        <div className="solutions-tab-group ml-4" role="tablist">
          <a
            role="tab"
            aria-selected={ariaSelected(0)}
            tabIndex={tab === 0 ? 0 : -1}
            href={""}
            className={"tablinks " + tabSelected(0)}
            ref={el => tabRefs.current[0] = el}
            onClick={e => {
              e.preventDefault();
              setTab(0);
            }}
            onKeyDown={e => handleKeyDown(e, 0)}
          >
            <Text category={props.category} id={props.navigationCardTab1} />
          </a>
          <a
            role="tab"
            aria-selected={ariaSelected(1)}
            tabIndex={tab === 1 ? 0 : -1}
            href={""}
            className={"tablinks " + tabSelected(1)}
            ref={el => tabRefs.current[1] = el}
            onClick={e => {
              e.preventDefault();
              setTab(1);
            }}
            onKeyDown={e => handleKeyDown(e, 1)}
          >
            <Text category={props.category} id={props.navigationCardTab2} />
          </a>
          {props.navigationCardTab3 !== undefined && (
            <a
              role="tab"
              aria-selected={ariaSelected(2)}
              tabIndex={tab === 2 ? 0 : -1}
              href={""}
              className={"tablinks " + tabSelected(2)}
              ref={el => tabRefs.current[2] = el}
              onClick={e => {
                e.preventDefault();
                setTab(2);
              }}
              onKeyDown={e => handleKeyDown(e, 2)}
            >
              <Text category={props.category} id={props.navigationCardTab3} />
            </a>
          )}
          {props.navigationCardTab4 !== undefined && (
            <a
              role="tab"
              aria-selected={ariaSelected(3)}
              tabIndex={tab === 3 ? 0 : -1}
              href={""}
              className={"tablinks " + tabSelected(3)}
              ref={el => tabRefs.current[3] = el}
              onClick={e => {
                e.preventDefault();
                setTab(3);
              }}
              onKeyDown={e => handleKeyDown(e, 3)}
            >
              <Text category={props.category} id={props.navigationCardTab4} />
            </a>
          )}
          {props.navigationCardTab5 !== undefined && (
            <a
              role="tab"
              aria-selected={ariaSelected(4)}
              tabIndex={tab === 4 ? 0 : -1}
              href={""}
              className={"tablinks " + tabSelected(4)}
              ref={el => tabRefs.current[4] = el}
              onClick={e => {
                e.preventDefault();
                setTab(4);
              }}
              onKeyDown={e => handleKeyDown(e, 4)}
            >
              <Text category={props.category} id={props.navigationCardTab5} />
            </a>
          )}
        </div>
      </div>
      <div className="power-platform-background" hidden={tab !== 0}>
        {props.navigationCardContent1}
      </div>
      <div className="power-platform-background" hidden={tab !== 1}>
        {props.navigationCardContent2}
      </div>
      {props.navigationCardContent3 !== undefined && (
        <div className="power-platform-background" hidden={tab !== 2}>
          {props.navigationCardContent3}
        </div>
      )}
      {props.navigationCardContent4 !== undefined && (
        <div className="power-platform-background" hidden={tab !== 3}>
          {props.navigationCardContent4}
        </div>
      )}
      {props.navigationCardContent5 !== undefined && (
        <div className="power-platform-background" hidden={tab !== 4}>
          {props.navigationCardContent5}
        </div>
      )}
    </section>
  );
};
export default NavigationCard;
